export const CREATE_VENUE_FAILED_MESSAGE = 'Something went wrong whilst creating a venue.';
